// SEQ-180 follow-up (14 September 2026): the KPI card's surface tints.
//
// THE BUG THIS EXISTS TO PREVENT COMING BACK. The card built its background,
// its border and its icon well by concatenating a hex alpha suffix onto the
// metric's colour: `${color}0d`, `${color}25`, `${color}18`. That only works
// when `color` is a six-digit hex. The widget renderer's fallback presentation
// is `var(--seq-blue)`, a token, so every KPI a user built on a metric outside
// the eight preset ones produced the string `var(--seq-blue)0d`. That is not a
// colour; the browser dropped all three declarations, and that card alone
// rendered with no background, no border and an untinted icon well while its
// neighbours had all three. It shipped, and it was found by looking at a
// screenshot rather than by any test.
//
// A pure module rather than a helper inside the component, so the behaviour
// can be proven under Deno instead of pinned by reading the component's source
// for a spelling.

/**
 * A percentage of a colour laid over whatever is behind it.
 *
 * `color-mix` takes a hex and a custom property alike, which is the whole
 * point: the presets render exactly as they did (their old `0d` suffix was
 * 5.1%) and a token-coloured card is finally tinted at all. There is repo
 * precedent in Login.css and PnlWidgetEditor.css.
 */
export function cardTint(colour: string, percent: number): string {
  return `color-mix(in srgb, ${colour} ${percent}%, transparent)`;
}

/** The three tint strengths a KPI card uses, named so the card reads as a decision rather than three magic numbers. */
export const CARD_TINT = {
  /** The top of the background gradient. 5% is what the old `0d` suffix worked out to. */
  surface: 5,
  /** The bottom of it, almost clear. */
  surfaceFade: 1.5,
  /** The border. */
  edge: 15,
  /** The well behind the icon. */
  icon: 10,
} as const;
